import {Fragment, useEffect, useState} from 'react'
import {Controller, useFormState} from 'react-hook-form'
import FormHelperText from '@mui/material/FormHelperText'
import {MuiOtpInput} from 'mui-one-time-password-input'
import PropTypes from 'prop-types'

import './otpInput.scss'

const OtpInput = ({name = 'code', control, error, className, ...props}) => {
  const {submitCount} = useFormState({control})
  // react-hook-form revalidates on every keystroke once a form has been
  // submitted, which made the length `validate` failure flash an over-eager
  // "OTP Invalid" while the user was still typing. Gate the validation feedback
  // on a submit attempt and clear it again as soon as the user resumes typing,
  // so the message only ever appears in response to an actual submit.
  const [showValidationFeedback, setShowValidationFeedback] = useState(false)

  useEffect(() => {
    if (submitCount > 0) setShowValidationFeedback(true)
  }, [submitCount])

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: 'Code is required',
        validate: value => value.length === 6
      }}
      render={({field, fieldState}) => {
        const showValidationError = showValidationFeedback && fieldState.invalid
        const showError = !!error || showValidationError

        return (
          <Fragment>
            <MuiOtpInput
              {...props}
              {...field}
              onChange={value => {
                setShowValidationFeedback(false)
                field.onChange(value)
              }}
              autoFocus
              className={className}
              sx={{gap: 1, marginBottom: '12px'}}
              length={6}
              TextFieldsProps={{error: showError}}
            />
            {
              showError && (
                <FormHelperText error>
                  {
                    showValidationError && fieldState.error?.type === 'validate' ?
                      'OTP Invalid' :
                      fieldState.error?.message || error
                  }
                </FormHelperText>)
            }
          </Fragment>
        )
      }}
    />
  )
}

OtpInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  control: PropTypes.object.isRequired,
  error: PropTypes.string
}

export default OtpInput
